import React from 'react';
import PropTypes from 'prop-types';
import { Line } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler,
} from 'chart.js';
import './DeviceDetailModal.css';

// Registramos los componentes necesarios para Chart.js
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler
);

const chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
        legend: {
            labels: { color: '#ffffff', font: { family: "'Share Tech Mono', monospace" } }
        }
    },
    layout: {
        padding: {
            bottom: 20
        }
    },
    color: '#fff',
    scales: {
        x: { 
            ticks: { color: '#ccc', maxTicksLimit: 10 },
            grid: { color: 'rgba(255, 255, 255, 0.1)' } 
        },
        y: { beginAtZero: true, max: 100, ticks: { color: '#ccc' }, grid: { color: 'rgba(255, 255, 255, 0.1)' } },
        y1: { type: 'linear', display: true, position: 'right', ticks: { color: '#39ff14' }, grid: { drawOnChartArea: false } }
    }
};

const DeviceDetailModal = ({ device, onClose, onCommand, commandStatus, chartData }) => {
    
  React.useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, []);

  if (!device) return null;

  const statusClassName = device.isOnline ? 'online' : 'offline';

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="modal-close-button" onClick={onClose}>&times;</button>
        
        <div className="modal-header">
          <h2>{device.type} - &ldquo;{device.name}&rdquo;</h2>
          <div className={`status-indicator ${statusClassName}`}></div>
        </div>

        <div className="modal-body">
          <div className="device-info">
            <h4>Detalles del Agente</h4>
            <p><strong>ID:</strong> {device.id}</p>
            <p><strong>Estado:</strong> <span className={statusClassName}>{device.isOnline ? 'En línea' : 'Desconectado'}</span></p>
            <p><strong>Última Conexión:</strong> {new Date(device.lastSeen).toLocaleString()}</p>
            <p><strong>Propietario:</strong> {device.ownerId}</p>
          </div>
          
          <div className="modal-chart-container">
            <h4>Telemetría</h4>
            <Line data={chartData} options={chartOptions} />
          </div>
        </div>

        <div className="modal-actions">
          <h4>Panel de Control</h4>
          <button 
            onClick={() => onCommand(device.id)}
            disabled={commandStatus.loading}
          >
            {commandStatus.loading ? 'Enviando...' : 'Actualizar Telemetría'}
          </button>
          
          {commandStatus.message && (
            <p className="command-feedback">{commandStatus.message}</p>
          )}

          <button disabled>Dispensar Medicamento</button>
          <button disabled>Reiniciar Agente</button>
        </div>
      </div>
    </div>
  );
};

DeviceDetailModal.propTypes = {
  device: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
  onCommand: PropTypes.func.isRequired,
  commandStatus: PropTypes.object.isRequired,
  chartData: PropTypes.object.isRequired,
};

export default DeviceDetailModal;
